module.exports = __webpack_public_path__ + "img/andrew-johnson.1cf62c38.png";